import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import { FeatureFlagContext } from "../../../../mp-core/FeatureFlagProvider/FeatureFlagProvider"
import { AppContext } from "../../../../mp-core/context"
import { RootState } from "../../../../mp-core/redux/store/index"
import { NavItem } from "../../../types/index"
import {
  getAvailableNavItemsUnderFeatureFlagAndLicense,
  getRedirectPath
} from "../helpers"
import { LicensesSet } from "../../../../mp-database"

export const useNavItemsUnderFeatureFlagAndLicense = (
  navItem: NavItem,
  defaultPath = "/reporting"
) => {
  const { featureFlags, featureFlagsLoading } = useContext(FeatureFlagContext)
  const { state: appState } = useContext(AppContext)

  const { user, userLicenses } = useSelector((state: RootState) => ({
    user: state.users.testUser,
    userLicenses: state.licenses.userlicenses as LicensesSet[]
  }))

  // Get isACTDistrict from AppContext district data
  const isACTDistrict = appState?.district?.record?.isACTDistrict || false

  const moduleNavItems: NavItem[] = useMemo(() => {
    if (featureFlagsLoading) return null

    const filteredNavItems = getAvailableNavItemsUnderFeatureFlagAndLicense(
      navItem,
      featureFlags,
      userLicenses,
      isACTDistrict,
      user?.role
    )

    return !!filteredNavItems ? [filteredNavItems] : []
  }, [
    featureFlags,
    featureFlagsLoading,
    userLicenses,
    isACTDistrict,
    user?.role
  ])

  const getRedirectPathForRoute = getRedirectPath(
    moduleNavItems?.[0],
    user.role,
    defaultPath
  )

  return { moduleNavItems, getRedirectPathForRoute }
}
